import { getDefaultDBEntityDocument, } from "utils-library/dist/db-entity-interfaces";
export const getDefaultIDeviceMgtmSettings = () => getDefaultDBEntityDocument({
    devicesCommunicationTimeout: 5000,
    defaultDevicesOutdatedMsThreshold: 5000,
    defaultDevicesDeadMsThreshold: 60000,
});
